
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/mobile-responsive",
      function () {
        return require("private-next-pages/sub/mobile-responsive.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/mobile-responsive"])
      });
    }
  